<template>
  <v-form>
    <v-row align="center" justify="center">
      <v-col cols="12">
        <v-row align="center">
          <v-col cols="12" md="6">
            <h1>จัดการลอตเตอรี่</h1>
          </v-col>
          <v-col cols="12" md="6" class="text-md-right">
            <div class="mb-2">
              <v-chip
                :color="isStoreOpen ? 'green' : 'red'"
                dark
                class="mr-2 mb-2"
              >
                {{ isStoreOpen ? "ร้านเปิดอยู่" : "ร้านปิดอยู่" }}
              </v-chip>
              <v-btn
                :color="isStoreOpen ? 'red' : 'green'"
                dark
                class="mb-2"
                :loading="storeStatusLoading"
                :disabled="storeStatusLoading"
                @click="toggleStoreStatus()"
              >
                {{ isStoreOpen ? "ปิดร้าน" : "เปิดร้าน" }}
              </v-btn>
            </div>
            <div>
              <v-chip
                :color="isCurrentResultVisible ? 'green' : 'orange'"
                dark
                class="mr-2 mb-2"
              >
                {{
                  isCurrentResultVisible
                    ? "ผลรางวัลงวดปัจจุบันเปิดอยู่"
                    : "ผลรางวัลงวดปัจจุบันถูกซ่อน"
                }}
              </v-chip>
              <v-btn
                :color="isCurrentResultVisible ? 'orange' : 'green'"
                dark
                class="mb-2"
                :loading="resultVisibilityLoading"
                :disabled="resultVisibilityLoading"
                @click="toggleCurrentResultVisibility()"
              >
                {{
                  isCurrentResultVisible ? "ซ่อนผลรางวัล" : "เปิดผลรางวัล"
                }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12">
        <h1>สรุปยอด</h1>
      </v-col>
      <v-col cols="12">
        <h3>
          รวมจำนวน Lottery ในระบบ:
          <v-chip color="green" dark>
            {{ totalLot }}
          </v-chip>
          ใบ / ยอดคงเหลือที่ยังไม่ขาย:
          <v-chip color="green" dark>
            {{ totalNotSell }}
          </v-chip>
          ใบ
        </h3>
      </v-col>
      <v-col cols="12">
        <v-card
          ><v-data-table
            :headers="headersLottoReportQuota"
            :items="reportDataQuota"
            :search="search"
            :items-per-page="-1"
            class="elevation-1"
          >
            <template v-slot:[`item.urlImage`]="{ item }">
              <v-img
                :src="item.urlImage"
                max-height="50px"
                max-width="100px"
                class="ma-2"
              ></v-img>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-chip v-if="item.status == 'PENDING'" color="orange" dark>
                รอการชำระเงิน
              </v-chip>
              <v-chip v-if="item.status == 'รอดำเนินการ'" color="yello" dark>
                รอดำเนินการ
              </v-chip>
              <v-chip v-if="item.status == 'SUCCESS'" color="green" dark>
                ชำระเงินสำเร็จ
              </v-chip>
              <!-- <v-chip v-if="item.status == 'ส่งEMSแล้ว'" color="blue" dark>
                ส่งEMSแล้ว
              </v-chip> -->
              <v-chip v-if="item.status == 'มีปัญหา'" color="red" dark>
                มีปัญหา
              </v-chip>
              <v-chip v-if="item.status == 'ยกเลิก'" color="brown" dark>
                ยกเลิก
              </v-chip>
              <!-- <v-chip v-if="item.status == 'ถูกจัดส่งแล้ว'" color="green" dark
                ><v-icon>mdi-check-circle</v-icon>{{ item.status }}</v-chip
              > -->
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-row justify="center">
                <!-- <v-icon @click="viewForm3(item)">mdi-eye</v-icon> -->
                <v-icon @click="goToDupp(item)">mdi-content-copy</v-icon>
                <v-icon @click="UpdateLotto(item)" class="mx-2"
                  >mdi-pencil</v-icon
                >
                <v-icon @click="DeleteLotto(item)">mdi-delete</v-icon>
              </v-row>
            </template>
          </v-data-table></v-card
        >
      </v-col>
      <v-col cols="12">
        <v-card
          ><v-data-table
            :headers="headersLottoReport"
            :items="reportData"
            :search="search"
            :items-per-page="10"
            class="elevation-1"
          >
            <template v-slot:[`item.urlImage`]="{ item }">
              <v-img
                :src="item.urlImage"
                max-height="50px"
                max-width="100px"
                class="ma-2"
              ></v-img>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-chip v-if="item.status == 'PENDING'" color="orange" dark>
                รอการชำระเงิน
              </v-chip>
              <v-chip v-if="item.status == 'รอดำเนินการ'" color="yello" dark>
                รอดำเนินการ
              </v-chip>
              <v-chip v-if="item.status == 'SUCCESS'" color="green" dark>
                ชำระเงินสำเร็จ
              </v-chip>
              <!-- <v-chip v-if="item.status == 'ส่งEMSแล้ว'" color="blue" dark>
                ส่งEMSแล้ว
              </v-chip> -->
              <v-chip v-if="item.status == 'มีปัญหา'" color="red" dark>
                มีปัญหา
              </v-chip>
              <v-chip v-if="item.status == 'ยกเลิก'" color="brown" dark>
                ยกเลิก
              </v-chip>
              <!-- <v-chip v-if="item.status == 'ถูกจัดส่งแล้ว'" color="green" dark
                ><v-icon>mdi-check-circle</v-icon>{{ item.status }}</v-chip
              > -->
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-row justify="center">
                <!-- <v-icon @click="viewForm3(item)">mdi-eye</v-icon> -->
                <v-icon @click="goToDupp(item)">mdi-content-copy</v-icon>
                <v-icon @click="UpdateLotto(item)" class="mx-2"
                  >mdi-pencil</v-icon
                >
                <v-icon @click="DeleteLotto(item)">mdi-delete</v-icon>
              </v-row>
            </template>
          </v-data-table></v-card
        >
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" md="4" sm="12">
            <!-- <v-menu
              ref="menufrom"
              v-model="menufrom"
              :close-on-content-click="false"
              :return-value.sync="datefrom"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="datefrom"
                  label="วันที่เริ่ม"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  dense
                  solo
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="datefrom"
                no-title
                scrollable
                :min="firstDate"
              >
                <v-btn text color="primary" @click="menufrom = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menufrom.save(datefrom)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu> -->
            <v-menu
              v-model="menufrom"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="datefrom"
                  label="เลือกงวดที่ออกรางวัล"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="datefrom"
                @input="menufrom = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-btn color="primary" @click="getAllLotto()">ค้นหา</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4" class="mr-4">
            <v-text-field
              class="mb-4"
              v-model="search"
              dense
              hide-details
              outlined
              placeholder="ค้นหา"
            ></v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col class="text-right">
            <v-btn @click="goToCreate()" color="primary" dark
              >เพิ่มลอตเตอรี่</v-btn
            >
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12">
        <v-card
          ><v-data-table
            :headers="headersLotto"
            :items="items"
            :search="search"
            :items-per-page="10"
            class="elevation-1"
          >
            <template v-slot:[`item.urlImage`]="{ item }">
              <v-img
                :src="item.urlImage"
                max-height="50px"
                max-width="100px"
                class="ma-2"
              ></v-img>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-row justify="center">
                <!-- <v-icon @click="viewForm3(item)">mdi-eye</v-icon> -->
                <v-icon @click="goToDupp(item)">mdi-content-copy</v-icon>
                <v-icon @click="UpdateLotto(item)" class="mx-2"
                  >mdi-pencil</v-icon
                >
                <v-icon @click="DeleteLotto(item)">mdi-delete</v-icon>
              </v-row>
            </template>
          </v-data-table></v-card
        >
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { Encode, Decode } from "@/services";
export default {
  data() {
    return {
      headersLotto: [
        { text: "ลำดับ", value: "count", align: "center" },
        { text: "รูป", value: "urlImage", align: "center" },
        { text: "หมายเลข", value: "lotteryNo", align: "center" },
        { text: "งวดประจำวันที่", value: "lotteryDate", align: "center" },
        { text: "จำนวน Stock", value: "stock", align: "center" },
        { text: "ตัวเลือก", value: "action", align: "center" },
        // count: 1
        // createdAt: "2021-04-24T18:16:52.000Z"
        // id: 132
        // lotteryDate: (...)
        // lotteryNo: 338541
        // owner: "admin"
        // price: 80
        // set: 51
        // stock: 0
        // time: 28
        // updatedAt: "2021-05-10T11:06:09.000Z"
        // urlImage: "https://readylotservice.readylotte
      ],
      headersLottoReport: [
        { text: "ชื่อร้านค้า", value: "name", align: "center" },
        { text: "สถานะ", value: "status", align: "center" },
        { text: "จำนวนคำสั่งซื้อ (ใบ)", value: "totalSale", align: "center" },
        // { text: "งวดประจำวันที่", value: "lotteryDate", align: "center" },
        // { text: "จำนวน Stock", value: "stock", align: "center" },
        // { text: "ตัวเลือก", value: "action", align: "center" },
      ],
      items: [],
      search: "",
      count: 0,
      user: "",
      datefrom: "",
      menufrom: false,
      reportData: [],
      totalLot: 0,
      totalNotSell: 0,
      headersLottoReportQuota: [
        { text: "ชื่อร้านค้า", value: "name", align: "center" },
        { text: "จำนวนคำสั่งซื้อ (ใบ)", value: "totalSale", align: "center" },
        { text: "โควต้าทั้งหมด (ใบ)", value: "quota", align: "center" },
        { text: "โควต้าคงเหลือ (ใบ)", value: "quotaLeft", align: "center" },
      ],
      reportDataQuota: [],
      lotteryDate: "",
      isStoreOpen: false,
      storeStatusLoading: false,
      isCurrentResultVisible: false,
      resultVisibilityLoading: false,
    };
  },
  created() {
    this.user = JSON.parse(Decode.decode(localStorage.getItem("DDLotAdmin")));
    this.getStoreStatus();
    this.getCurrentResultVisibility();
    this.getReport();
    this.getAllLotto();
  },
  methods: {
    async getStoreStatus() {
      this.storeStatusLoading = true;
      try {
        const auth = {
          headers: { Authorization: `Bearer ${this.user.token}` },
        };
        const response = await this.axios.get(
          `${process.env.VUE_APP_API}/configs/store-status`,
          auth
        );
        this.isStoreOpen = response.data.data.value1 == "1";
      } finally {
        this.storeStatusLoading = false;
      }
    },
    async getCurrentResultVisibility() {
      this.resultVisibilityLoading = true;
      try {
        const auth = {
          headers: { Authorization: `Bearer ${this.user.token}` },
        };
        const response = await this.axios.get(
          `${process.env.VUE_APP_API}/configs/current-result-visibility`,
          auth
        );
        this.isCurrentResultVisible = response.data.data.value1 == "1";
      } finally {
        this.resultVisibilityLoading = false;
      }
    },
    async getAllLotto() {
      const responseLotteryDate = await this.axios.get(
        `${process.env.VUE_APP_API}/configs/findLotteryDate`
      );
      this.lotteryDate = responseLotteryDate.data.data.value1;

      console.log(this.datefrom);
      const auth = {
        headers: { Authorization: `Bearer ${this.user.token}` },
      };
      const data = {
        id: "",
        lotteryDate: this.lotteryDate,
        stock: "",
        owner: "",
      };

      const response = await this.axios.post(
        `${process.env.VUE_APP_API}/lottery/getAll`,
        data,
        auth
      );
      console.log("getAllLotto", response.data.data);
      this.items = response.data.data;
      for (let i in this.items) {
        this.items[i].count = parseInt(i) + 1;
        //console.log(this.list);
      }
    },
    async getReport() {
      console.log(this.datefrom);
      const auth = {
        headers: { Authorization: `Bearer ${this.user.token}` },
      };
      const data = {
        id: "",
        lotteryDate: "",
        stock: "",
        owner: "",
      };

      const response = await this.axios.get(
        `${process.env.VUE_APP_API}/lottery/getReport`
      );
      console.log("Report", response.data);
      this.reportData = response.data.data;
      this.totalLot = response.data.total;

      const responseQuota = await this.axios.get(
        `${process.env.VUE_APP_API}/lottery/getReportQuota`,
        auth
      );

      console.log("responseQuota", responseQuota.data.data);

      this.reportDataQuota = responseQuota.data.data;
      const lastIndex = this.reportDataQuota.length - 1;
      if (this.reportDataQuota.length > 1) {
        this.totalNotSell =
          this.totalLot - this.reportDataQuota[lastIndex].totalSale;
      }
    },
    goToDupp(val) {
      localStorage.setItem("Lottodata", Encode.encode(val));
      this.$router.push("DupplicateLotto");
    },
    UpdateLotto(val) {
      localStorage.setItem("Lottodata", Encode.encode(val));
      this.$router.push("EditLotto");
    },
    async DeleteLotto(val) {
      this.$swal({
        text: "คุณต้องการลบข้อมูลใช่ หรือไม่ ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "ยกเลิก",
        confirmButtonText: "ต้องการลบข้อมูล",
      }).then(async (result) => {
        const auth = {
          headers: { Authorization: `Bearer ${this.user.token}` },
        };
        if (result.isConfirmed) {
          const response = await this.axios.delete(
            `${process.env.VUE_APP_API}/lottery/` + val.id,
            auth
          );
          console.log(response);

          this.$swal.fire({
            icon: "success",
            text: "ลบข้อมูลสำเร็จ",
            showConfirmButton: false,
            timer: 1000,
          });
          // await location.reload();
          this.getAllLotto();
        }
      });
    },
    goToCreate() {
      this.$router.push("createLotto");
    },
    async toggleStoreStatus() {
      const nextValue = this.isStoreOpen ? "0" : "1";
      const nextLabel = nextValue == "1" ? "เปิด" : "ปิด";
      const result = await this.$swal({
        text: `คุณต้องการ${nextLabel}ร้านใช่ หรือไม่ ?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "ยกเลิก",
        confirmButtonText: `ต้องการ${nextLabel}ร้าน`,
      });
      if (!result.isConfirmed) {
        return;
      }
      this.storeStatusLoading = true;
      try {
        const auth = {
          headers: { Authorization: `Bearer ${this.user.token}` },
        };
        const response = await this.axios.post(
          `${process.env.VUE_APP_API}/configs/store-status`,
          { value1: nextValue },
          auth
        );
        if (response.data.response_status == "SUCCESS") {
          this.isStoreOpen = response.data.data.value1 == "1";
          this.$swal.fire({
            icon: "success",
            text: `${nextLabel}ร้านสำเร็จ`,
            showConfirmButton: false,
            timer: 1200,
          });
          return;
        }
        this.$swal.fire({
          icon: "error",
          text: `${nextLabel}ร้านไม่สำเร็จ`,
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error) {
        this.$swal.fire({
          icon: "error",
          text: `${nextLabel}ร้านไม่สำเร็จ`,
          showConfirmButton: false,
          timer: 1500,
        });
      } finally {
        this.storeStatusLoading = false;
      }
    },
    async toggleCurrentResultVisibility() {
      const nextValue = this.isCurrentResultVisible ? "0" : "1";
      const nextLabel = nextValue == "1" ? "เปิด" : "ซ่อน";
      const result = await this.$swal({
        text: `คุณต้องการ${nextLabel}ผลรางวัลงวดปัจจุบันใช่ หรือไม่ ?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "ยกเลิก",
        confirmButtonText: `ต้องการ${nextLabel}ผลรางวัล`,
      });
      if (!result.isConfirmed) {
        return;
      }
      this.resultVisibilityLoading = true;
      try {
        const auth = {
          headers: { Authorization: `Bearer ${this.user.token}` },
        };
        const response = await this.axios.post(
          `${process.env.VUE_APP_API}/configs/current-result-visibility`,
          { value1: nextValue },
          auth
        );
        if (response.data.response_status == "SUCCESS") {
          this.isCurrentResultVisible = response.data.data.value1 == "1";
          this.$swal.fire({
            icon: "success",
            text: `${nextLabel}ผลรางวัลสำเร็จ`,
            showConfirmButton: false,
            timer: 1200,
          });
          return;
        }
        this.$swal.fire({
          icon: "error",
          text: `${nextLabel}ผลรางวัลไม่สำเร็จ`,
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error) {
        this.$swal.fire({
          icon: "error",
          text: `${nextLabel}ผลรางวัลไม่สำเร็จ`,
          showConfirmButton: false,
          timer: 1500,
        });
      } finally {
        this.resultVisibilityLoading = false;
      }
    },
  },
};
</script>
